// src/api/host.js
import request from "../utils/request";
const apiPrefix = "/host";

export const getHostList = (params) => {
  return request.get(`${apiPrefix}/list`, { params });
};
export const getValidHostOptions = () => {
  return request.get(`${apiPrefix}/validHostOptions`);
};
export const batchUpdateHosts = (ids, update) => {
  console.log("ids,update:", ids, update);
  return request.put(`${apiPrefix}/batch-update`, { ids, update });
};

export const searchHosts = (params) => {
  return request.get(`${apiPrefix}/search`, { params });
};
export const createHost = (data) => {
  return request.post(`${apiPrefix}/add`, data);
};
export const deleteHost = (id) => {
  return request.delete(`${apiPrefix}/delete/${id}`);
};
export const getHostDetail = (id) => request.get(`${apiPrefix}/${id}`);

export const updateHost = (id, data) => request.put(`${apiPrefix}/${id}`, data);
export const getHostRentContractList = (params) => {
  return request.post(`${apiPrefix}/contract/list`, params);
};
export const createHostRentContract = (data) => {
  return request.post(`${apiPrefix}/contract/add`, data);
};
export const deleteHostRentContract = (id) => {
  return request.delete(`${apiPrefix}/contract/${id}`);
};
export const updateHostRentContract = (id, data) => {
  return request.put(`${apiPrefix}/contract/${id}`, data);
};
export const getHostRentContractDetail = (id) => {
  return request.get(`${apiPrefix}/contract/${id}`);
};
export const checkRentContract = (id) => {
  return request.get(`${apiPrefix}/contract/check/${id}`);
};
export const moveOutRentContract = (id) => {
  return request.put(`${apiPrefix}/contract/move-out/${id}`);
};
export const moveOutScheduledRentContract = (id, data) => {
  return request.put(`${apiPrefix}/contract/move-out-schedule/${id}`, data);
};
export const getHostRentBillList = (params) => {
  return request.post(`${apiPrefix}/contractBill/list`, params);
};
export const createHostRentBill = (data) => {
  return request.post(`${apiPrefix}/contractBill/add`, data);
};
export const getHostRentBillDetail = (id) => {
  return request.get(`${apiPrefix}/contractBill/${id}`);
};
export const updateHostRentBill = (id, data) => {
  return request.put(`${apiPrefix}/contractBill/${id}`, data);
};
export const createFinancialRecord = (data) => {
  return request.post(`${apiPrefix}/financialRecord/add`, data);
};
export const getMeterReadingPending = (data) => {
  return request.get(`${apiPrefix}/meter-reading/pending`);
};
export const createMeterReadingRecord = (params) => {
  return request.post(`${apiPrefix}/meter-reading/add`, params);
};
export const getMeterReadinggRecord = (params) => {
  return request.get(`${apiPrefix}/meter-reading/search`, {
    params,
  });
};
export const getLastMeterReadingRecord = (params) => {
  return request.get(`${apiPrefix}/meter-reading/last`, {
    params,
  });
};

// 列表查询（分页+筛选）
export const getExpenseList = (params) => {
  return request.get(`${apiPrefix}/expense/list`, { params });
};

// 详情
export const getExpenseDetail = (id) => {
  return request.get(`${apiPrefix}/expense/${id}`);
};

// 新增
export const createExpense = (data) => {
  return request.post(`${apiPrefix}/expense`, data);
};

// 更新
export const updateExpense = (id, data) => {
  return request.put(`${apiPrefix}/expense/${id}`, data);
};

// 作废
export const voidExpense = (id) => {
  return request.patch(`${apiPrefix}/expense/${id}/void`);
};
